import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=504444b3&"
import script from "./MyHome.vue?vue&type=script&lang=js&"
export * from "./MyHome.vue?vue&type=script&lang=js&"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=504444b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports